import React, { Component } from 'react';
import ReportsLayout from '../../templates/reports';
import Surveys from '../../elements/reports/surveys';
import Loading from './../../elements/loading';

class ReportsSurveys extends Component{
	render (){
		const { reports } = this.props;
		const { expenses, surveys } = reports;
		return (
			surveys.isFetching || expenses.isFetching ? <Loading/>:<Surveys {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;

		//this.props.reportsExpenses(modality, state, municipality);
		this.props.reportsSurvey(modality, state, municipality);

	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {

			//this.props.reportsExpenses(modality, state, municipality);
			this.props.reportsSurvey(modality, state, municipality);
		}
	}
}

export default ReportsLayout(ReportsSurveys, {subnav: 4});


// WEBPACK FOOTER //
// ./src/layouts/reports/surveys.jsx